import React from 'react';
import { COUCHES } from './couches';
import Compteur from './Compteur';

export default function Legende({ totaux, actives, setActives, disponibles = COUCHES.map((c) => c.id), clair = false }) {
  const bascule = (id) => setActives((a) => (a.includes(id) ? a.filter((x) => x !== id) : [...a, id]));
  return (
    <div className="grid grid-cols-2 gap-3 lg:grid-cols-4" data-testid="carte-vivante-legende">
      {COUCHES.filter((c) => disponibles.includes(c.id)).map((c) => {
        const on = actives.includes(c.id);
        return (
          <button key={c.id} type="button" onClick={() => bascule(c.id)} data-testid={`carte-couche-${c.id}`} aria-pressed={on}
            className={`group rounded-2xl border p-4 text-left transition-[transform,opacity,border-color] duration-200 hover:-translate-y-0.5 ${on ? 'opacity-100' : 'opacity-45'} ${clair ? 'border-slate-200 bg-white' : 'border-white/10 bg-white/5'}`}
            style={{ borderColor: on ? c.couleur : undefined }}>
            <span className="flex items-center gap-2 text-xs font-semibold uppercase tracking-wider" style={{ color: c.couleur }}>
              <span className="relative flex h-2.5 w-2.5"><span className="absolute inline-flex h-full w-full animate-ping rounded-full opacity-60" style={{ background: c.couleur }} /><span className="relative inline-flex h-2.5 w-2.5 rounded-full" style={{ background: c.couleur }} /></span>
              {c.court}
            </span>
            <Compteur valeur={totaux?.[c.id] || 0} className={`mt-2 block text-3xl font-bold ${clair ? 'text-slate-900' : 'text-white'}`} testid={`carte-total-${c.id}`} />
            <span className={`text-[11px] ${clair ? 'text-slate-500' : 'text-slate-400'}`}>{on ? 'affiché · cliquer pour masquer' : 'masqué · cliquer pour afficher'}</span>
          </button>
        );
      })}
    </div>
  );
}
